import { FormLayout, Input } from '@panwds/react-form';
import { Sheet, SheetBody, Link } from "@panwds/react-ui";
import { useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslate } from "../../../../../customHooks";
import { FormattedMessage } from "react-intl";
import { DOCUMENTATION_URLS } from './constants';
import { PrivateAccessEditProps, PrivateAccessConfig } from './types';

export const PrivateAccessEdit = (props: PrivateAccessEditProps) => {
    const { close, editPrivateAccess, editPrivateAccessData, disabled = false } = props;
    const translate = useTranslate();

    const formMethods = useForm({defaultValues: editPrivateAccessData});
    const {
        formState: { isDirty, }
    } = formMethods

    const resourceConfigType = formMethods.watch('ResourceConfigType');

    const onSubmit = useCallback(
        async (data: PrivateAccessConfig) => {
            editPrivateAccess(data);
        }, [editPrivateAccess]
    );

    return (
        <>
         <Sheet
            onClose={() => close()}
            title={translate(`generic.viewDetails`)}
            isOpen
            showMask={true}
            position="md"
        >
            <SheetBody>
                <div className="tw-relative">
                    <FormProvider {...formMethods}>
                        <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                            <FormLayout>
                                <Input
                                    label={translate('generic.name')}
                                    name="Name"
                                    dataMetrics="cloudngfw-firewall-private=-access-edit-name"
                                    placeholder={translate('resources.firewallsV2.privateAccess.customName')}
                                    disabled
                                />
                                <Input
                                    label={translate(`resources.firewallsV2.privateAccess.resourceType`)}
                                    name="Type"
                                    dataMetrics="cloudngfw-firewall-private=-access-edit-type"
                                    disabled
                                />
                                <div>
                                    <Input
                                        label={translate('resources.firewallsV2.privateAccess.host')}
                                        name="Host"
                                        dataMetrics="cloudngfw-firewall-private=-access-edit-agent-ip"
                                        disabled
                                    />
                                    <div className="tw-text-xs tw-text-gray-600 tw-mt-1">
                                        <FormattedMessage
                                            id="resources.firewallsV2.privateAccess.hostHelpText"
                                            values={{
                                                document: (
                                                    <Link external href={DOCUMENTATION_URLS.USER_ID_AGENT} target="_blank" rel="noopener noreferrer">
                                                        document
                                                    </Link>
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                <Input
                                    label={translate('resources.firewallsV2.privateAccess.resourceConfigType')}
                                    name="ResourceConfigType"
                                    dataMetrics="cloudngfw-firewall-private-access-edit-resource-config-type"
                                    disabled
                                />
                                <div>
                                    <Input
                                        name="ResourceArn"
                                        label={translate('resources.firewallsV2.privateAccess.AWSResourceId')}
                                        dataMetrics="cloudngfw-firewall-private-access-edit-aws-resource-id"
                                        disabled
                                    />
                                    <div className="tw-text-xs tw-text-gray-600 tw-mt-1">
                                        <FormattedMessage
                                            id="resources.firewallsV2.privateAccess.AWSResourceIdHelpText"
                                            values={{
                                                document: (
                                                    <Link external href={DOCUMENTATION_URLS.RESOURCE_GATEWAY} target="_blank" rel="noopener noreferrer">
                                                        document
                                                    </Link>
                                                )
                                            }}
                                        />
                                    </div>
                                </div>

                                {resourceConfigType === 'Group' && (
                                    <div>
                                        <Input
                                            name="ChildResourceArn"
                                            label={translate('resources.firewallsV2.privateAccess.childResourceARN')}
                                            dataMetrics="cloudngfw-firewall-private-access-edit-child-resource-arn"
                                            disabled
                                        />
                                        <div className="tw-text-xs tw-text-gray-600 tw-mt-1">
                                            <FormattedMessage
                                                id="resources.firewallsV2.privateAccess.childResourceARNHelpText"
                                                values={{
                                                    document: (
                                                        <Link external href={DOCUMENTATION_URLS.RESOURCE_GATEWAY} target="_blank" rel="noopener noreferrer">
                                                            document
                                                        </Link>
                                                    )
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* <div className="tw-flex tw-justify-end">
                                    <Button addClassName='tw-mr-2' appearance={"secondary"} onClick={() => close()}>
                                        {translate("generic.cancel")}
                                    </Button>
                                    <SubmitButton disabled={ !isDirty }>{translate(`generic.edit`)}</SubmitButton>
                                </div> */}
                            </FormLayout>
                        </form>
                    </FormProvider>
                </div>
            </SheetBody>
        </Sheet>
    </>
    );
};

PrivateAccessEdit.displayName = 'PrivateAccessEdit';
